// extracted by mini-css-extract-plugin
export default {"wrap":"messageList_wrap__hTx+N","wrap2":"messageList_wrap2__vT1P2","wrap3":"messageList_wrap3__gPHeL","message":"messageList_message__-1Eoy"};